import {Component} from '@angular/core';

import {InstanceDiscoveredEmojiComponent} from './instance-discovered-emoji.component';

@Component({
  selector: 'app-instance-discovered-text',
  standalone: true,
  imports: [InstanceDiscoveredEmojiComponent],
  templateUrl: './instance-discovered-text.component.html',
  styleUrl: './instance-discovered-text.component.css',
})
export class InstanceDiscoveredTextComponent {}
